export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/alert.constants.js